import workspaceQuery from '../../../graphql/queries/sales/DispatchInstructionsWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/sales/DispatchInstructionsFragment.graphql';

import * as printFunctions from '../../../actions/sales/DispatchPrintFunctions';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

import DispatchInstructionSingleReportMutation from '../../../graphql/mutations/sales/DispatchInstructionSingleReportMutation.graphql';
import DispatchInstructionReportMutation from '../../../graphql/mutations/sales/DispatchInstructionReportMutation.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const workspaceUrl = '/Sales/DispatchInstructions/Workspace/';

export enum DispatchInstructionWorkspaceAction {
  NOTIFY_MAXOPTRA = 'DI_NOTIFY_MAXOPTRA',
  PRINT_DISPATCH_INSTRUCTIONS = 'PRINT_DISPATCH_INSTRUCTIONS',
}

const workspaceActionsForPermissions = [
  {
    description: 'Print dispatch instructions',
    actionReference: DispatchInstructionWorkspaceAction.PRINT_DISPATCH_INSTRUCTIONS,
  },
  {
    description: 'Notify Maxoptra',
    actionReference: DispatchInstructionWorkspaceAction.NOTIFY_MAXOPTRA,
  },
];

const DispatchInstructions: EntityType = {
  type: 'DispatchInstruction',
  title: 'Dispatch Instructions',
  workspaceUrl: workspaceUrl,
  workspace: workspaceQuery,
  generate: DispatchInstructionSingleReportMutation,
  generateRange: DispatchInstructionReportMutation,
  fragment,
  printFunctions: printFunctions,
  screenReference: 'DISPATCH_INSTRUCTIONS',
  actions: workspaceActionsForPermissions,
  configuration: {
    title: 'Delivery Notes',
    field: 'deliveryNoteDefault',
    reportType: ReportType.SalesDeliveryNote,
    customerField: 'customerDeliveryNoteDefault',
    receiveFlag: 'receiveDeliveryNotes',
  },
  operations: ALLOW_VIEW, //Not 0 like other documents because there are further actions available.
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'consignmentReference',
      text: 'Easypost Consignment Reference',
    },
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default DispatchInstructions;
